import { render, staticRenderFns } from "./sortable-label.component.vue?vue&type=template&id=3784ff0d&scoped=true"
import script from "./sortable-label.component.vue?vue&type=script&lang=js"
export * from "./sortable-label.component.vue?vue&type=script&lang=js"
import style0 from "./sortable-label.component.vue?vue&type=style&index=0&id=3784ff0d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3784ff0d",
  null
  
)

export default component.exports